import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { PropTypes as PropTypes$1 } from '@micromag/core';
import { getStyleFromMargin, getStyleFromText, getStyleFromBox } from '@micromag/core/utils';

var styles = {"container":"micromag-element-text-input-container","element":"micromag-element-text-input-element"};

var propTypes = {
  label: PropTypes.string,
  labelOutside: PropTypes.bool,
  labelClassName: PropTypes.string,
  textStyle: PropTypes$1.textStyle,
  buttonStyle: PropTypes$1.boxStyle,
  labelOutsideStyle: PropTypes$1.textStyle,
  margin: PropTypes$1.margin,
  multiline: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  focusable: PropTypes.bool,
  className: PropTypes.string
};
var defaultProps = {
  label: null,
  labelOutside: false,
  labelClassName: null,
  textStyle: null,
  buttonStyle: null,
  labelOutsideStyle: null,
  margin: null,
  multiline: false,
  value: '',
  onChange: null,
  onFocus: null,
  onBlur: null,
  required: false,
  disabled: false,
  focusable: true,
  className: null
};
var TextInput = function TextInput(_ref) {
  var label = _ref.label,
    labelOutside = _ref.labelOutside,
    labelClassName = _ref.labelClassName,
    textStyle = _ref.textStyle,
    buttonStyle = _ref.buttonStyle,
    labelOutsideStyle = _ref.labelOutsideStyle,
    margin = _ref.margin,
    multiline = _ref.multiline,
    value = _ref.value,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    required = _ref.required,
    disabled = _ref.disabled,
    focusable = _ref.focusable,
    className = _ref.className;
  var containerStyle = {};
  var labelStyle = {};
  var elementStyle = {};
  if (margin !== null) {
    containerStyle = _objectSpread(_objectSpread({}, containerStyle), getStyleFromMargin(margin));
  }
  if (labelOutsideStyle !== null) {
    labelStyle = _objectSpread(_objectSpread({}, labelStyle), getStyleFromText(labelOutsideStyle));
  }
  if (textStyle !== null) {
    elementStyle = _objectSpread(_objectSpread({}, elementStyle), getStyleFromText(textStyle));
  }
  if (buttonStyle !== null) {
    elementStyle = _objectSpread(_objectSpread({}, elementStyle), getStyleFromBox(buttonStyle));
  }
  var containerProps = {
    className: classNames([styles.container, _defineProperty(_defineProperty({}, className, className !== null), styles.element, !labelOutside)]),
    style: containerStyle
  };
  var elementProps = _objectSpread(_objectSpread({
    className: styles.element
  }, !labelOutside ? containerProps : null), {}, {
    style: elementStyle,
    placeholder: !labelOutside ? label : undefined,
    value: value,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    required: required,
    disabled: disabled
  });
  var element = multiline ? /*#__PURE__*/React.createElement("textarea", Object.assign({}, elementProps, {
    tabIndex: focusable ? '0' : '-1'
  })) : /*#__PURE__*/React.createElement("input", Object.assign({}, elementProps, {
    type: "text",
    tabIndex: focusable ? '0' : '-1'
  }));
  return !labelOutside ? element : /*#__PURE__*/React.createElement("label", containerProps, /*#__PURE__*/React.createElement("div", {
    className: labelClassName,
    style: labelStyle
  }, label), element);
};
TextInput.propTypes = propTypes;
TextInput.defaultProps = defaultProps;

export { TextInput as default };
